import ServicesComparsion from "@/components/appServicesComparison";
import { TABLE_DATA } from "./constants";

const KubernetesTable = () => {
  return <ServicesComparsion {...TABLE_DATA} />;
};

export default KubernetesTable;
